import { render } from "./LatestTransactions.vue?vue&type=template&id=0ee9f297"
import script from "./LatestTransactions.vue?vue&type=script&lang=js"
export * from "./LatestTransactions.vue?vue&type=script&lang=js"
script.render = render

export default script